// setGroupConnector — VQE-Edit edit-action: flip a WHERE group's connector
// (AND↔OR) by path. Delegates to SR-Edit `set-connector` via `commitEdit`.

import type {
  BooleanClauseTarget,
  NodePath,
  WhereCombinator,
} from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Flip the connector joining the children of the group at `groupPath` to
 * `connector`, in the WHERE (default) or HAVING (`clause: 'having'`) tree.
 * No-op (SR-Edit returns no planned edits) when the group has fewer than two
 * children or already uses `connector`.
 */
export async function setGroupConnector(
  groupPath: NodePath,
  connector: WhereCombinator,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  await commitEdit({ op: 'set-connector', groupPath, connector, clause }, ctx);
}
